import { formatSys2OdooDate } from "@heartfulnessinstitute/react-hfn-forms/dist/formatting";
import { daysDiff } from "@heartfulnessinstitute/react-hfn-forms/dist/utils";
import { commonSelectorswithPreprocess } from "../selector-template-generator";

const strings = require("../../care-app/strings.json");

const status_options = Object.entries(strings.status_opts).map((e) => ({
  name: e[0],
  label: e[1],
}));
const problem_options = Object.entries(strings.problem_opts).map((e) => ({
  name: e[0],
  label: e[1],
}));
const referredby_options = Object.entries(strings.referredby_opts).map((e) => ({
  name: e[0],
  label: e[1],
}));

export const usersConfig = {
  fields: (create_mode, all_patients_page, trainer_options, i_am_admin) => {
    const edit_mode = !create_mode;
    const not_admin = !i_am_admin;

    const disabled_only_edit_non_admin = edit_mode && not_admin;

    return [
      {
        name: "name",
        label: strings.usersdb.name,
        type: "text",
        props: {
          disabled: !all_patients_page && !create_mode,
          pattern: "^[A-Za-z]+( [A-Za-z]+)*$",
        },
      },
      {
        name: "gender",
        label: strings.usersdb.gender,
        type: "gender",
        props: { gridInline: 135, disabled: disabled_only_edit_non_admin },
      },
      {
        name: "age",
        label: strings.usersdb.age,
        type: "number",
        props: {
          min: 1,
          max: 100,
          required: false,
          gridInline: 80,
          disabled: disabled_only_edit_non_admin,
        },
      },

      {
        name: "city",
        type: "text",
        label: strings.usersdb.city,
        pattern: "^[A-Za-z]+( [A-Za-z]+)*$",
      },
      { name: "country", label: strings.usersdb.country, type: "country" },
      {
        name: "state",
        label: strings.usersdb.state,
        type: "indiastate",
        props: { required: false },
      },
      {
        name: "email",
        label: strings.usersdb.email,
        type: "email",
        props: { required: true, transform: "email" },
      },
      {
        name: "mobile",
        label: strings.usersdb.mobile,
        type: "phone",
        props: { required: false, gridInline: 135 },
      },
      {
        name: "phone2",
        label: strings.usersdb.phone2,
        type: "phone",
        props: { required: false, gridInline: 135 },
      },
      {
        name: "caretrainers",
        label: strings.usersdb.caretrainers,
        type: "multiselect",
        options: trainer_options,
        props: { disabled: disabled_only_edit_non_admin },
      },

      {
        name: "status",
        label: strings.usersdb.status,
        type: "select",
        options: status_options,
      },
      {
        name: "activities",
        label: strings.usersdb.activities,
        props: { required: false },
        hide: true,
      },

      {
        name: "abhyasiid",
        type: "text",
        label: strings.usersdb.abhyasiid,
        props: {
          required: false,
          disabled: disabled_only_edit_non_admin,
          transform: "abhyasiid",
        },
      },
      {
        name: "polarity",
        label: strings.usersdb.polarity,
        type: "toggle",
        props: { disabled: disabled_only_edit_non_admin },
      },
      {
        name: "problem",
        label: strings.usersdb.problem,
        props: { required: true, disabled: disabled_only_edit_non_admin },
        type: "select",
        options: problem_options,
      },

      {
        name: "referred_by",
        label: strings.usersdb.referred_by,
        type: "select",
        options: referredby_options,
        props: { disabled: disabled_only_edit_non_admin },
      },
      {
        name: "referred_by_other",
        type: "text",
        label: strings.usersdb.referred_by_other,
        dynamic: (r) =>
          r.referred_by === "Other"
            ? {
                props: {
                  required: true,
                  disabled: disabled_only_edit_non_admin,
                },
              }
            : {
                hide: true,
                props: {
                  required: false,
                  disabled: disabled_only_edit_non_admin,
                },
              },
      },
      {
        name: "added_on",
        label: "Added On",
        type: "date",
        props: { required: false, pastDatesOnly: true },
      },
    ];
  },

  collection: "CareUsers",
  primaryKey: "id",
  defaults: {},
};

const usersCollection = usersConfig.collection;
const MY_USERS = "MyUsers";

export const queryUsers = () => ({
  collection: usersCollection,
  orderBy: "name",
});

export const queryUsersMine = (who_am_i = "", trainer = "") => ({
  collection: usersCollection,
  where: [
    "caretrainers",
    "array-contains-any",
    [who_am_i.toLowerCase().trim(), trainer].filter(Boolean),
  ],
  storeAs: MY_USERS,
});

export const selectorUsers = (state) => state.firestore.data[usersCollection];
export const selectorUsersOrdered = (state) =>
  state.firestore.ordered[usersCollection];
export const selectorUsersId = (state, docId) =>
  state.firestore.data[usersCollection][docId];

export const selectorUsersMine = (state) => state.firestore.data[MY_USERS];
export const selectorUsersMineId = (state, docId) =>
  state.firestore.data[MY_USERS][docId];
export const selectorUsersMineOrdered = (state) =>
  state.firestore.ordered[MY_USERS];

const today = formatSys2OdooDate(new Date());

export const preprocessUsers = (user) => ({
  ...user,
  ...("last_sitting_date" in user && !!user.last_sitting_date
    ? {
        // last_sitting_date: doFormatShortDate(
        //   user.activities[user.activities.length - 1].date
        // ),
        last_sitting_type: "Started",
        last_sitting_days: daysDiff(today, user.last_sitting_date),
      }
    : {
        last_sitting_date: "",
        last_sitting_type: strings.misc.not_started,
        last_sitting_days:
          "added_on" in user ? daysDiff(today, user.added_on) : "-1001",
      }),
});

export const queryPatients = queryUsers;
export const patientsConfig = usersConfig;
export const postprocessPatients = (r) => {
  if (r.added_by && r.added_by_name) return r;
  const ret = { ...r };
  const authInfo = JSON.parse(localStorage.getItem("authInfo"));
  ret.added_by = authInfo?.user_email;
  ret.added_by_name = authInfo?.name;
  return ret;
};
export const preprocessPatients = preprocessUsers;
export const patientsSelectors = () =>
  commonSelectorswithPreprocess(patientsConfig.collection, preprocessPatients);
export const validatePatients = (/* r */) => "";

export const queryPatientsMine = queryUsersMine;
export const patientsMineSelectors = () =>
  commonSelectorswithPreprocess(MY_USERS, preprocessPatients);

// const myUsersSelector = createSelector(selectorUsersMineOrdered, (users) => {
//   if (!isLoaded(users)) {
//     return users;
//   }
//   return users.map(preprocessUsers);
// });

export const savePatients = (dbStore, patient, payload) => {
  dbStore.setMerge(patientsConfig.collection, patient, payload).catch(() => {
    /* console.error */
  });
};
